import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FontAwesomeIcons } from 'src/app/constants/icons';

@Component({
  templateUrl: './icon-dialog.component.html',
  styleUrls: ['./icon-dialog.component.css']
})
export class IconDialogComponent {
  searchQuery: string = '';
  icons: { name: string, label: string }[] = FontAwesomeIcons;
  selectedIcon: { name: string, label: string } = null;


  constructor(public dialogRef: MatDialogRef<IconDialogComponent>) {
    
  }

  get filteredIcons() {
    return this.icons.filter(icon =>
      icon.label.toLowerCase().includes(this.searchQuery.toLowerCase()) || icon.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
  }
}